import { AcCellStatus, AcStatusType } from "components/AcStatus/AcStatus"

interface OrderCellStatusProps {
    status?: string
    dataTestId?: string
}

export const OrderCellStatus = ({ status, dataTestId }: OrderCellStatusProps) => {
    if (!status) return null
    return (
        <AcCellStatus
            theme="light"
            type={status as unknown as AcStatusType}
            dataTestId={dataTestId}
        />
    )
}